import { useEffect } from "react";

/**
 * Sets `document.title` for as long as the calling component stays
 * mounted, restoring whatever title was set before it (for example the
 * default `Leeft MFT` from index.html, or another page's title during a
 * fast client-side navigation) once it unmounts.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
